<template lang="pug">
v-container
  v-row
    h2 Reglas contables 
    v-spacer
    v-spacer
    v-btn(rounded outlined color='primary' @click='agregar()') Añadir conjunto de reglas
  v-row
    v-col( sm='12' md='6' v-for='movimiento, index in registro_movimientos_contables' :key='index || ""')
      v-card
        v-card-title
          v-container
            v-row
              v-edit-dialog( :return-value.sync='movimiento.nombre' label='Nombre' lazy @save='actualizar({key: movimiento.key, movimiento: movimiento})' @change='actualizar({key: movimiento.key, movimiento: movimiento})')
                h5 {{movimiento.nombre ? movimiento.nombre : 'Nombre del conjunto de reglas'}}
                template(v-slot:input='')
                  v-text-field(v-model='movimiento.nombre' label='Nombre del conjunto de reglas' @change='actualizar({key: movimiento.key, movimiento: movimiento})' single-line)
              v-spacer
              v-tooltip(top)
                template(v-slot:activator="{ on }") 
                  v-btn( @click='agregar_regla(movimiento.key, movimiento.reglas) ; actualizar({key: movimiento.key, movimiento: movimiento})' icon v-on='on')
                      v-icon( small ) fas fa-plus
                span Agregar regla
              v-tooltip(top)
                template(v-slot:activator="{ on }")
                  v-btn( @click='eliminar(movimiento.key)' icon v-on='on')
                      v-icon( small ) far fa-trash-alt
                span Eliminar conjunto de reglas
        v-card-text
          v-container
            v-row(v-for='item, subindice in movimiento.reglas' :key=`${index}${subindice}`)
              v-col.pa-1
                v-edit-dialog(lazy @save='actualizar({key: movimiento.key, movimiento: movimiento})') {{ item.nombre_de_regla ? item.nombre_de_regla : 'Nombre de la regla'}}
                  template(:return-value.sync='item.nombre_de_regla' v-slot:input)
                    v-text-field(label='Nombre de la regla' v-model='item.nombre_de_regla' @change='actualizar({key: movimiento.key, movimiento: movimiento})' outlined)
              v-col.xs1.pa-1
                v-text-field(type='number' label='Porcentaje (%)' v-model.number='item.porcentaje' outlined @change='actualizar({key: movimiento.key, movimiento: movimiento})')
              v-col.xs3.pa-1
                v-autocomplete(label='Debe' v-model='item.debe' :items='partidas_contables_record' :item-text='item=>item.codigo+" / "+item.descripcion' @change='actualizar({key: movimiento.key, movimiento: movimiento})' :item-value='item=>item.codigo')
              v-col.xs3.pa-1
                v-autocomplete(label='Haber' v-model='item.haber' :items='partidas_contables_record' :item-text='item=>item.codigo+" / "+item.descripcion' @change='actualizar({key: movimiento.key, movimiento: movimiento})' :item-value='item=>item.codigo')
              v-spacer
              v-tooltip(top)
                template(v-slot:activator="{ on }")
                  v-btn(@click='eliminar_regla(item, movimiento.reglas) ; actualizar({key: movimiento.key, movimiento: movimiento})' icon v-on='on').mt-1
                    v-icon( small ) fas fa-minus
                span Eliminar regla
            v-row
              v-combobox(
                multiple 
                v-model="movimiento.codigos_de_operaciones_aplicables" 
                :items="operationsRecord"  
                item-text='name' 
                item-value='code' 
                label='Operaciones aplicables' 
                @change='actualizar({key: movimiento.key, movimiento: movimiento})'
              )
              
</template>
<script>
import { mapGetters, mapActions, mapMutations,mapState } from 'vuex'
export default {
    data: ()=>({
      search: ''
    }),
    computed:{
      ...mapGetters({
        registro_movimientos_contables: 'Movimientos_contables/registro',
        partidas_contables_record: 'Partidas_Contables/record',
        operationsRecord: 'Operations/record',
      }),
      ...mapState({
        partidas_contables: state => state.PartidasContables
      })
    },
    methods: {
      ...mapActions({
        agregar: 'Movimientos_contables/agregar',
        eliminar: 'Movimientos_contables/eliminar',
        actualizar: 'Movimientos_contables/actualizar',
        obtener_todo: 'Movimientos_contables/getAll',
        registro_contable: 'Movimientos_contables/movimiento_contable'
      }),
      async prueba(){
        await this.registro_contable({valor: 100, regla: "Nueva"})
      },
      agregar_regla(key, reglas){
        reglas.push({
          nombre_de_regla: '',
          debe: '', 
          haber: '',
          porcentaje: 0
        })
      },
      eliminar_regla(item, reglas){
        reglas.splice(reglas.indexOf(item), 1)
      }
    }
}
</script>
